<template>
  <portal to="global-modal-portal" v-if="showModal && usePortal" :order="5">
    <b-modal :active.sync="showModal" scroll="keep" :has-modal-card="true" :canCancel="false" id="cpo-intention-approval-modal">
      <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Accept CPO Intention</p>
        </header>
      <section class="modal-card-body">
        <div class="notification is-flex is-warning">
          <span><i class="fas fa-exclamation-triangle is-warning fa-2x"></i></span>
          <span class="ml-10">
            Warning!! CPO intention is set to blocked on inventory record.
          </span>
        </div>
      </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" @click="acceptCpoIntention()" type="button">Yes</button>
        </footer>
      </div>
    </b-modal>
  </portal>
  <b-modal id="cpo-intention-approval-modal" :active.sync="showModal" scroll="keep" :has-modal-card="true" :canCancel="false" v-else-if="showModal && !usePortal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Accept CPO Intention</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-flex is-warning">
          <span><i class="fas fa-exclamation-triangle is-warning fa-2x"></i></span>
          <span class="ml-10">
            Warning!! CPO intention is set to blocked on inventory record.
          </span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-danger" @click="acceptCpoIntention()" type="button">Ok</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'CpoIntentionApprovalControl',
  components: {
  },
  props: {
    showCpoIntentionModal: {
      type: Boolean,
      default: false
    },
    usePortal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
  },
  methods: {
    showCpoIntentionApprovalModal: function () {
      this.showModal = true
    },
    acceptCpoIntention: function () {
      this.showModal = false
    }
  },
  watch: {
    showCpoIntentionModal: function (newValue, oldValue) {
      if (newValue) {
        this.showCpoIntentionApprovalModal()
      } else {
        this.showModal = false
      }
    }
  },
  mounted: function () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
